import { PropertyDocViewComponent } from '@/components/property-doc-view/property-doc-view.component';
import { ObjectUpdatedType } from '@/enums/ObjectUpdatedType.enum';
import { AppConstants } from '@/helpers/app.constants';
import { PropertyHelper } from '@/helpers/property.helper';
import { AppConfigService } from '@/services/app-config.service';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PropertyCategory, RealProperty } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { PropertyDocViewComponent as PropertyDocViewComponent_1 } from '../../../components/property-doc-view/property-doc-view.component';
import { PropertyRoomTableComponent } from '../../../components/property-room-table/property-room-table.component';
import { NgIf } from '@angular/common';
import { PropertyAttributesViewComponent } from '../../../components/property-attributes-view/property-attributes-view.component';

@Component({
    selector: 'app-property-building',
    templateUrl: './property-building.component.html',
    styleUrls: ['./property-building.component.scss'],
    standalone: true,
    imports: [PropertyAttributesViewComponent, NgIf, PropertyRoomTableComponent, PropertyDocViewComponent_1]
})
export class PropertyBuildingComponent implements OnInit, OnDestroy {
  @ViewChild(PropertyDocViewComponent) docComponent: PropertyDocViewComponent;
  @Input() prop: RealProperty;

  editGroupCode: string;
  isRoomFeatureAvailable = false;

  sub = new Subscription();

  category = PropertyCategory.BUILDING;
  constructor(
    private propHelper: PropertyHelper,
    private appConfigService: AppConfigService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.editGroupCode = this.route.snapshot.queryParams[AppConstants.PARAM_EDIT_GROUP_CODE];
    this.isRoomFeatureAvailable =
      // Alloawed only on types HOUSE, FLAT, BUSINESS, FARM
      this.propHelper.isHouse(this.prop) ||
      this.propHelper.isFlat(this.prop) ||
      this.propHelper.isBusiness(this.prop) ||
      this.propHelper.isFarm(this.prop);

    this.sub = this.appConfigService.objectUpdated.subscribe((type) => {
      if (type === ObjectUpdatedType.DOC) {
        this.refreshDocList();
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  refreshDocList() {
    if (this.docComponent) {
      this.docComponent.loadDocList();
    }
  }
}
